<template>
  <div class="homework">
    <van-nav-bar title="提交作业" left-text="返回" left-arrow @click-left="$router.go('-1')" />
    <div class="de-page">
      <div class="de-top">
        <div class="det-title">{{ info.title }}</div>
        <div>班级：{{ className }}</div>
        <div>时间：{{ info.createdAt }} 发布</div>
        <div>提交截止时间：{{ info.other && info.other.submitEndTime }}</div>
        <div>权限：提交后仅老师可见</div>
      </div>

      <div class="de-cont">
        <div class="dec-tip">详情</div>
        <div class="dec-conts">
          <div class="content">
            <div style="font-size: 14px">任务描述</div>
            <div style="padding-left: 5px; line-height: 22px">
              {{ info.content }}
            </div>
          </div>

          <div class="dec-fs">
            <span class="dec-lable">提交方式：{{ info.other && info.other.submitType }}</span>
          </div>
          <div class="imgview">
            <div class="imgs" v-for="(it, index) in attachment" :key="index">
              <img :src="it" class="img" @click="openImg(attachment, index)" />
              <div class="iconcross" v-if="isShowbrn">
                <van-icon name="cross" color="#FFFFFF" size="2" @click="delImg(index)" />
              </div>
            </div>
            <div v-if="info.other &&info.other.submitType === '图片'">
              <van-uploader
                v-model="fileList"
                multiple
                :after-read="afterRead"
                :before-read="beforeRead"
                deletable
                @delete="onDelete"
                :max-count="9"
                v-if="isShowbrn"
              />
            </div>
          </div>

          <div class="de-cont" v-if="info.other &&info.other.submitType === '文字'">
            <div class="dec-conts">
              <van-field
                v-model="content"
                rows="2"
                autosize
                type="textarea"
                maxlength="200"
                placeholder="请输入"
                show-word-limit
              />
            </div>
          </div>
        </div>
      </div>

      <div class="btn-box" v-if="isShowbrn">
        <van-button type="default" style="width: 45%; color: #6ebeff" @click="$router.go('-1')"
          >取消</van-button
        >
        <van-button type="primary" style="width: 45%" @click="submit">提交</van-button>
      </div>

      <div class="icon-box" v-if="isExits">
        <div v-if="isIcon" class="icos-view">
          <!-- <img src="../../assets/images/edit4.png" class="icons" @click="delHome" /> -->
          <img src="../../assets/images/edit5.png" class="icons" @click="updata" />
        </div>
        <img src="../../assets/images/edit5.png" class="icons" @click="updata" />
        <!-- <img src="../../assets/images/bianji.png" class="icons" @click="handShowicon" /> -->
      </div>
    </div>
    <!-- 提交弹出层 -->
    <van-dialog
      v-model="showDialog"
      title="提示"
      show-cancel-button
      @confirm="handleAddNamePosition"
      @cancel="this.showDialog = false"
    >
      <div style="text-align: center; padding: 20px">{{ this.words }}</div>
    </van-dialog>
  </div>
</template>
<script>
import { Icon, Field, Uploader, Button, Dialog, Toast, ImagePreview } from 'vant'
import { basePath } from '../../api/index'
import axios from 'axios'

var hesuanforms = null
export default {
  data() {
    return {
      content: '',
      attachment: [],
      fileList: [],
      isIcon: false,
      showDialog: false,
      phone: '',
      publishId: '',
      studentId: '',
      info: {},
      className: '',
      isExits: null,
      isShowbrn: true,
      picfile: null,
      picList: [],
      homeworkDO: null,
      words:null
    }
  },
  created() {
    this.publishId = this.$route.query.publishId
    this.studentId = this.$route.query.studentId
    this.phone = localStorage.getItem('phone')
    this.getDetail()
    this.getCheck()
  },
  components: {
    'van-icon': Icon,
    'van-field': Field,
    'van-uploader': Uploader,
    'van-button': Button,
    'van-image-preview': ImagePreview,
    [Dialog.Component.name]: Dialog.Component,
  },

  methods: {
    getDetail() {
      let api = this.$api.homework.detail
      this.$http
        .get(api, {
          studentId: this.studentId,
          publishId: this.publishId,
        })
        .then((data) => {
          if (data.code == 0) {
            const res = data.data
            this.info = res
            if (res.homeworkDO) {
              this.homeworkDO = res.homeworkDO
              this.attachment = res.homeworkDO.attachment.split(',')
            }

            if (res.classInfoDTO && res.classInfoDTO.length > 0) {
              let names = res.classInfoDTO.map((item) => {
                return item.className
              })
              this.className = names.join(',')
            }
          }
        })
    },

    //判断是不是提交过
    getCheck() {
      let api = this.$api.homework.check
      this.$http
        .get(api, {
          studentId: this.studentId,
          publishId: this.publishId,
        })
        .then((data) => {
          if (data.code == 0) {
            const res = data.data
            if (res.isExits) {
              this.isShowbrn = false
              this.words = res.words
            }
            this.isExits = res.isExits
          }
        })
    },

    //选择图片
    afterRead(file) {
      console.log(file)
      this.picfile = file
      hesuanforms = new FormData()
      hesuanforms.append('fileType', 'IMAGE')
      hesuanforms.append('file', file.file) //获取上传图片信息
      this.picUpload()
    },
    beforeRead(file) {
      if (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png') {
        return true
      }
      Toast('请上传符合格式的图片')
      return false
    },

    onDelete(file, index) {
      this.picList.splice(index, 1)
    },

    //图片上传
    picUpload() {
      //如果文件列表为空，则不需要调用上传
      if (hesuanforms == null || hesuanforms.length == 0) {
        return
      }
      if (this.picfile != null) {
        this.picfile.status = '上传中'
      }

      axios({
        method: 'post',
        url: basePath + this.$api.homework.upload,
        data: hesuanforms,
      })
        .then((res) => {
          if (res.code == 0) {
            Toast.success('上传成功')
            this.picList.push(res.data)
          } else {
            Toast.fail(res.msg)
            this.picfile.status = '上传失败'
          }
        })
        .catch((err) => {
          Toast.fail('图片上传失败')
        })
    },

    handleAddNamePosition() {
      this.onSubmit()
    },

    // 提交
    submit() {
      if (this.words) {
        return (this.showDialog = true)
      } else {
        this.onSubmit()
      }
    },

    onSubmit() {
      let api = ''
      if (this.isExits) {
        api = this.$api.homework.update
      } else {
        api = this.$api.homework.commit
      }

      if (this.info.other.submitType === '文字' && this.content === '') {
        return Toast('请输入作业内容')
      }

      if (this.words) {
        if (this.info.other.submitType === '图片' && this.attachment.length < 1) {
          return Toast('请上传作业图片')
        }
      } else {
        if (this.info.other.submitType === '图片' && this.picList.length < 1) {
          return Toast('请上传作业图片')
        }
      }
      this.$http
        .json_post(api, {
          content: this.content,
          attachment: this.attachment.concat(this.picList).join(', '),
          studentId: this.studentId,
          publishId: this.publishId,
          phone: this.phone,
        })
        .then((data) => {
          if (data.code == 0) {
            const res = data.data
            this.$router.push({ name: 'success', query: { data: res } })
          }
        })
    },

    openImg(data, index) {
      ImagePreview({
        images: data,
        startPosition: index,
        closeable: true,
      })
    },

    delImg(index) {
      this.attachment = this.attachment.splice(index, 1)
    },

    //更改作业
    updata() {
      this.isShowbrn = true
    },

    handShowicon() {
      this.isIcon = !this.isIcon
    },
    delHome() {
      this.showDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
.imgview {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding-left: 8px;
  padding-bottom: 10px;
  .imgs {
    height: 79px;
    width: 79px;
    margin-right: 8px;
    margin-bottom: 8px;
    position: relative;
    .img {
      height: 100%;
      width: 100%;
    }
    .iconcross {
      background-color: rgba(0, 0, 0, 0.7);
      padding-bottom: 2px;
      padding-left: 2px;
      position: absolute;
      border-bottom-left-radius: 15px;
      top: 0px;
      right: 0px;
      z-index: 10;
    }
  }
}
.homework {
  height: 100%;
}
.de-page {
  position: relative;
  height: 100%;
}
.de-top {
  padding: 15px 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #2c2d32;
  line-height: 20px;
  .det-title {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 15px;
  }
}

.de-cont {
  margin-bottom: 10px;
  .dec-tip {
    padding-left: 21px;
    font-weight: 600;
    font-size: 12px;
    color: #6ebeff;
  }
  .dec-conts {
    margin: 4px 12px;
    border: 1px solid #6ebeff;
    border-radius: 10px;
    background: #fff;
    white-space: pre-wrap;
    .dec-fs {
      background: #f3f5f9;
      margin: 13px 10px;
      padding: 4px 8px;
      font-weight: 500;
      font-size: 12px;
      color: #acafb5;
      line-height: 30px;
    }
    .dec-lable {
      font-weight: 600;
      font-size: 14px;
      color: #3b3b3b;
      margin-right: 5px;
    }
  }
  .content {
    padding: 17px 0 0 8px;
    font-weight: 600;
    font-size: 12px;
    color: #3b3b3b;
  }
}

.btn-box {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}

.icon-box {
  position: absolute;
  right: 10px;
  bottom: 100px;
}
.icos-view {
  display: flex;
  flex-direction: column;
}
.icons {
  height: 60px;
  width: 60px;
}

.van-cell {
  border-radius: 10px;
  margin-bottom: 10px;
}
</style>
